// Lots of VNTG — cart drawer enhancements
(function () {
  'use strict';

  var STAR_FULL = '<svg width="20" height="20" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="3" fill="#00B67A"/><polygon fill="white" points="20,7 23.9,15.4 33,16.6 26.5,22.9 28.2,32 20,27.8 11.8,32 13.5,22.9 7,16.6 16.1,15.4"/></svg>';
  var STAR_EMPTY = '<svg width="20" height="20" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="3" fill="#dcdce6"/><polygon fill="white" points="20,7 23.9,15.4 33,16.6 26.5,22.9 28.2,32 20,27.8 11.8,32 13.5,22.9 7,16.6 16.1,15.4"/></svg>';

  function formatMoney(cents) {
    var euros = cents / 100;
    return '€' + euros.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/,00$/, ',-');
  }

  function applyCartStyles() {
    document.querySelectorAll('#CartDrawer [name="checkout"], cart-drawer [name="checkout"]').forEach(function(btn) {
      btn.style.setProperty('background-color', '#111', 'important');
      btn.style.setProperty('color', '#fff', 'important');
      btn.style.setProperty('border-color', '#111', 'important');
      btn.style.setProperty('border-radius', '12px', 'important');
      btn.style.setProperty('font-size', '1.5rem', 'important');
      btn.style.setProperty('font-weight', '700', 'important');
      btn.style.setProperty('min-height', '5.6rem', 'important');
      btn.style.setProperty('padding', '1.5rem 2rem', 'important');
      btn.style.setProperty('flex', '1 1 100%', 'important');
      btn.textContent = 'Afrekenen';
    });
    document.querySelectorAll('#CartDrawer .drawer__footer-buttons .btn--secondary, cart-drawer .drawer__footer-buttons .btn--secondary').forEach(function(btn) {
      btn.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('#CartDrawer .drawer__heading, cart-drawer .drawer__heading').forEach(function(h) {
      h.style.setProperty('width', '100%', 'important');
      h.style.setProperty('justify-content', 'center', 'important');
      h.style.setProperty('text-align', 'center', 'important');
    });
    document.querySelectorAll('#CartDrawer .cart-drawer__header, cart-drawer .cart-drawer__header').forEach(function(h) {
      h.style.setProperty('align-items', 'center', 'important');
    });
  }

  function addTrustpilot() {
    var forms = document.querySelectorAll('#CartDrawer .drawer__footer-buttons, cart-drawer .drawer__footer-buttons');
    forms.forEach(function(form) {
      if (form.parentNode.querySelector('.vntg-trustpilot')) return;
      var tp = document.createElement('div');
      tp.className = 'vntg-trustpilot';
      tp.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:8px;padding:1rem 0 0.2rem;margin-top:0.8rem;border-top:1px solid rgba(0,0,0,0.08);';
      tp.innerHTML =
        '<span style="font-size:1.25rem;font-weight:700;color:#191919;">Uitstekend</span>' +
        '<div style="display:flex;gap:2px;">' + STAR_FULL + STAR_FULL + STAR_FULL + STAR_FULL + STAR_EMPTY + '</div>' +
        '<span style="font-size:1.2rem;font-weight:800;letter-spacing:-0.02em;color:#191919;">Trustpilot</span>';
      form.parentNode.insertBefore(tp, form.nextSibling);
    });
  }

  function removeBadges() {
    document.querySelectorAll('.vntg-savings-badge').forEach(function(el) { el.remove(); });
  }

  function injectBadges() {
    removeBadges();
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart || !cart.items) return;
        cart.items.forEach(function(item) {
          if (!item.compare_at_price || item.compare_at_price <= item.original_price) return;
          var savings = item.compare_at_price - item.original_price;
          if (savings <= 0) return;
          var itemEl = document.querySelector('.cart-item[data-variant-id="' + item.variant_id + '"]');
          if (!itemEl) {
            var allItems = document.querySelectorAll('#CartDrawer .cart-item, cart-drawer .cart-item');
            var prefix = item.product_title.substring(0, 15);
            for (var i = 0; i < allItems.length; i++) {
              var titleEl = allItems[i].querySelector('.cart-item__product a, .cart-item__title');
              if (titleEl && titleEl.textContent.trim().indexOf(prefix) === 0) { itemEl = allItems[i]; break; }
            }
          }
          if (!itemEl || itemEl.querySelector('.vntg-savings-badge')) return;
          var priceEl = itemEl.querySelector('.price--on-sale, .price');
          if (!priceEl) return;
          var badge = document.createElement('div');
          badge.className = 'vntg-savings-badge';
          badge.style.cssText = 'display:inline-flex;align-items:center;gap:0.4rem;background:#e6f7ef;color:#1a7a4a;border-radius:20px;padding:0.3rem 0.9rem;font-size:1.2rem;font-weight:600;margin-top:0.5rem;line-height:1.4;';
          badge.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><polyline points="20 6 9 17 4 12"></polyline></svg> U bespaart ' + formatMoney(savings);
          priceEl.parentNode.insertBefore(badge, priceEl.nextSibling);
        });
      })
      .catch(function() {});
  }

  function applyAll() {
    applyCartStyles();
    addTrustpilot();
    injectBadges();
  }

  var timer;
  function debounced() { clearTimeout(timer); timer = setTimeout(applyAll, 200); }

  applyCartStyles();

  ['cart:updated','cart-drawer:open','cart-drawer:refresh','cart:open','drawer:open'].forEach(function(e) {
    document.addEventListener(e, debounced);
  });

  function setupObserver() {
    var drawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function(muts) {
      if (muts.some(function(m) { return m.addedNodes.length > 0; })) debounced();
    }).observe(drawer, { childList: true, subtree: true });
    new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.attributeName === 'hidden' && !drawer.hasAttribute('hidden')) {
          setTimeout(applyAll, 50);
          setTimeout(applyAll, 400);
        }
      });
    }).observe(drawer, { attributes: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { applyAll(); setupObserver(); });
  } else {
    applyAll();
    setupObserver();
  }
})();
